// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__ccZ9e","footer-heading":"footer_footer-heading__146X0","footer-list":"footer_footer-list__GfjSA","contact-info":"footer_contact-info__NylCu"};